import './app.css';

function App() {
  return (
    <div className="container">
      <div className="card">
        <h1>Kopā Jautrāk</h1>
        <p>
          projekts ir mainījis nosaukumu uz <strong>Party Swiper</strong>
        </p>
        <p>
          Spied uz adresi, ja vēlies uzzināt vairāk:
        </p>

        <a 
          href="https://partyswiper.com/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="button"
        >
          Party Swiper
        </a>
      </div>
    </div>
  );
}

export default App;